// src/pages/BundeslandBremen.jsx
import React from "react";
import BundeslandPage from "./BundeslandPage";
import { bremen } from "../components/states/bremen";

export default function BundeslandBremen() {
  return <BundeslandPage data={bremen} />;
}

